import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="relative w-full bg-accent-50/50 py-20 md:py-28">
      <div className="w-full max-w-3xl mx-auto px-6 md:px-10 text-center">
        <p className="text-xs font-semibold tracking-widest text-accent-600 uppercase mb-6">
          Latest SEO Guide
        </p>

        <article>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-8 leading-snug">
            How the ACBuy Spreadsheet Transforms the Way You Shop Online in 2026
          </h2>

          <div className="text-left space-y-5">
            <p className="text-base text-foreground-700 leading-relaxed">
              In a world where online shopping can feel overwhelming, the <strong>acbuy spreadsheet</strong> emerges
              as a breath of fresh air for savvy consumers. Unlike traditional browsing methods that scatter your
              attention across countless tabs, this innovative product intelligence system consolidates everything
              you need—prices, ratings, trend data, and category comparisons—into one beautifully structured
              interface. Whether you are hunting for the latest sneakers, tracking hoodie collections, or simply
              trying to find the best deal on everyday essentials, the acbuy spreadsheet eliminates the noise and
              brings clarity to your shopping decisions.
            </p>

            <p className="text-base text-foreground-700 leading-relaxed">
              What truly sets the <strong>acbuyspreadsheet</strong> apart is its commitment to transparency. Every
              product entry is updated daily, ensuring you work with fresh, accurate data rather than stale listings.
              The system organizes items across fourteen curated categories—from Shoes and T-Shirts to Accessories
              and Perfumes—making it effortless to jump between sections without losing your place. Users consistently
              report cutting their research time by over seventy percent, freeing up hours each week for what actually
              matters. It is not just a tool; it is a smarter way to navigate the modern e-commerce landscape.
            </p>

            <p className="text-base text-foreground-700 leading-relaxed">
              For those who value efficiency without sacrificing quality, the <strong>acbuy spreadsheet</strong> offers
              an unmatched combination of speed, depth, and ease of use. The mobile-optimized design means you can
              check prices and compare products from anywhere—your morning commute, a coffee break, or while relaxing
              at home. As the digital marketplace grows more complex by the day, having a centralized shopping
              intelligence tool is no longer a luxury; it is a competitive advantage. Discover why thousands of users
              have already made the switch to a more intelligent way of shopping.
            </p>
          </div>

          <div className="mt-10">
            <Link
              to="/acbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all duration-300 hover:scale-105"
            >
              Read Full Article
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
}